import React from 'react'
import { useState } from 'react'
import { useTranslation } from 'react-i18next'
import Modal from '../../partials/Modal'
import { Form } from './HeroSection'
import Lottie from 'react-lottie-player';
import whale from '../../img/whale.json'

function BannerSection() {
    const { t } = useTranslation();
    const [isModalOpen, setIsModalOpen] = useState(false);
      
    const openModal = () => {
        setIsModalOpen(true)
    }
      
    const closeModal = () => {
        setIsModalOpen(false);
    }

    return (
        <section className="bannerTxt p-5">
            <div className='whaleContainer'>
                <Lottie
                    loop
                    animationData={whale}
                    play
                    speed={1}
                    className="whale"
                />
            </div>
            <span>{t('bannerTxt')}</span>
            <button className='btn align-self-start my-10' style={{'width': 'fit-content', 'margin': '25px auto 0'}} onClick={openModal}>{t('heroBtn')}</button>
            <Modal 
                isOpen={isModalOpen} 
                closeModal={closeModal} 
                title = {t('contactFormTitle')}
                content = {<Form />}
              />
        </section>
    )
}

export default BannerSection